var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['wit-section-paragraph', _vm.$mq]},[_c('div',{staticClass:"wit-section-paragraph-container container-xl"},[_c('div',{staticClass:"col-md-9",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }